import { GetAllFeatureFlagsQuery } from "~/gql/queries/featureFlag.generated";

export const featureFlagEndpoints = {
	GetAllFeatureFlags: {
		providesTags: ["FeatureFlag"] as AddTagTypes,
		transformResponse: (res: GetAllFeatureFlagsQuery) => res
	}
};
